import React, { useEffect } from 'react'
import { translate } from '../../selectors/translations'
import useSWR from "swr"
import { apiV2 } from "../../repositories/repository"
import {
  lineChartConfig,
} from "../patients/PatientGameStats/PatientGameStatsCommon"
import { Chart } from "chart.js/auto"
import dayjs from "dayjs"
import { ProgramTaskActionType } from "../../sdk"

const Program: React.FC = () => {
  const {
    data: results,
    isLoading,
  } = useSWR(
    'api.program.getGeneralStats',
    () => apiV2.program.getGeneralStats(),
    {revalidateOnFocus: false}
  )
  useEffect(() => {
    if (!results) {
      return
    }
    const charts: Chart[] = []
    const twoMonthsAgo = dayjs().subtract(2, 'months')
    const freshResults = {
      checkinsByDay: results.checkinsByDay.filter(e => dayjs(e.date).isAfter(twoMonthsAgo)),
      tasksByDay: results.tasksByDay.filter(e => dayjs(e.day).isAfter(twoMonthsAgo)),
    }
    console.log(freshResults)

    // @ts-ignore
    const uniqueDates: string[] = freshResults.checkinsByDay.map(e => dayjs(e.date).format('MM/DD'))
    const checkinsData = {
      labels: uniqueDates,
      datasets: [
        {
          label: 'Checkins',
          data: freshResults.checkinsByDay.map(e => e.checkins),
          borderColor: '#8fbc6b',
          borderWidth: 1,
          backgroundColor: 'rgba(82, 158, 0, 0.05)',
          fill: true,
          pointStyle: false,
          pointRadius: 4,
          pointHoverRadius: 8,
          cubicInterpolationMode: 'monotone',
        },
      ]
    }
    const tasksData = {
      labels: uniqueDates,
      datasets: [
        {
          label: 'Games',
          data: freshResults.tasksByDay.filter(e => e.action === ProgramTaskActionType.GAMES).map(e => e.checkins),
          borderColor: '#8fbc6b',
          borderWidth: 2,
          backgroundColor: 'rgba(82, 158, 0, 0.05)',
          fill: true,
          pointStyle: false,
          pointRadius: 4,
          pointHoverRadius: 8,
          cubicInterpolationMode: 'monotone',
        },
        {
          label: 'Sleep',
          data: freshResults.tasksByDay.filter(e => e.action === ProgramTaskActionType.SLEEP).map(e => e.checkins),
          borderColor: '#6b78bc',
          borderWidth: 2,
          backgroundColor: 'rgba(0,21,158,0.05)',
          fill: true,
          pointStyle: false,
          pointRadius: 4,
          pointHoverRadius: 8,
          cubicInterpolationMode: 'monotone',
        },
        {
          label: 'Steps',
          data: freshResults.tasksByDay.filter(e => e.action === ProgramTaskActionType.STEPS).map(e => e.checkins),
          borderColor: '#bc6b6b',
          borderWidth: 2,
          backgroundColor: 'rgba(158,0,0,0.05)',
          fill: true,
          pointStyle: false,
          pointRadius: 4,
          pointHoverRadius: 8,
          cubicInterpolationMode: 'monotone',
        },
        {
          label: 'Social interaction',
          data: freshResults.tasksByDay.filter(e => e.action === ProgramTaskActionType.SOCIAL_INTERACTION).map(e => e.checkins),
          borderColor: '#bb4fd3',
          borderWidth: 2,
          backgroundColor: 'rgba(113,0,158,0.05)',
          fill: true,
          pointStyle: false,
          pointRadius: 4,
          pointHoverRadius: 8,
          cubicInterpolationMode: 'monotone',
        },
        {
          label: 'Stress',
          data: freshResults.tasksByDay.filter(e => e.action === ProgramTaskActionType.STRESS).map(e => e.checkins),
          borderColor: '#4fd3b4',
          borderWidth: 2,
          backgroundColor: 'rgba(0,158,134,0.05)',
          fill: true,
          pointStyle: false,
          pointRadius: 4,
          pointHoverRadius: 8,
          cubicInterpolationMode: 'monotone',
        },
        {
          label: 'Diet',
          data: freshResults.tasksByDay.filter(e => e.action === ProgramTaskActionType.DIET).map(e => e.checkins),
          borderColor: '#d3b94f',
          borderWidth: 2,
          backgroundColor: 'rgba(158,113,0,0.05)',
          fill: true,
          pointStyle: false,
          pointRadius: 4,
          pointHoverRadius: 8,
          cubicInterpolationMode: 'monotone',
        },
      ]
    }

    const checkinsChartCtx = document.getElementById(`checkins`)
    if (checkinsChartCtx) {
      // @ts-ignore
      charts.push(new Chart(checkinsChartCtx, {
        ...lineChartConfig(),
        data: checkinsData
      }))
    }
    const tasksChartCtx = document.getElementById(`tasks`)
    if (tasksChartCtx) {
      // @ts-ignore
      charts.push(new Chart(tasksChartCtx, {
        ...lineChartConfig(),
        data: tasksData
      }))
    }

    return () => {
      charts.map(c => c.destroy())
    }
  }, [results])

  if (isLoading) {
    return (
      <div className="flex w-100 h-100 justify-center align-center">
        <p className="m-0">{translate('Loading...')}</p>
      </div>
    )
  }

  return (<>
    <div className="card-box">
      <h2>Checkins per day</h2>
      <canvas id="checkins" style={{maxHeight: '50vh'}}></canvas>
    </div>
    <div className="card-box">
      <h2>Task completeness</h2>
      <canvas id="tasks" style={{maxHeight: '50vh'}}></canvas>
    </div>
  </>)
}

export default Program
